export enum LotGoalWeightError {
  NonZero = "non-zero",
}

export function validateLotGoalWeight(
  weight: number | null
): LotGoalWeightError | null {
  if (weight != null && weight <= 0) {
    return LotGoalWeightError.NonZero;
  }

  return null;
}

export enum LotMeasuredWeightError {
  NonZero = "non-zero",
}

export function validateLotMeasuredWeight(
  weight: number | null
): LotMeasuredWeightError | null {
  if (weight != null && weight <= 0) {
    return LotMeasuredWeightError.NonZero;
  }

  return null;
}
